import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { Knowledge } from "./getKnowledgeForCandidate";

export interface SetKnowledgeForCandidateResponse extends BackendResponse {}
export interface SetKnowledgeForCandidateParameters extends NextApiParams {
  knowledge: Knowledge[];
  candidateId: number;
  firmId: number;
}

export interface SetKnowledgeForCandidateParameterItem {
  positionType: number;
  level: number;
}

export const setKnowledgeForCandidate = withNextApi<
  SetKnowledgeForCandidateResponse,
  SetKnowledgeForCandidateParameters
>("/cvp/CvpSetKnowledgeForCandidate");
